import React, { useState } from "react";
import styles from "./EditFields.module.css";


import { Card, CardBody, CardTitle, GridLayout, GridLayoutItem} from "@progress/kendo-react-layout";
import useBreakpoint from "use-breakpoint";
import ColumnEditFields from "./ColumnEditFields";
import { FormElement } from "@progress/kendo-react-form";
import { BREAKPOINTS } from "./constants/gridLayoutConstants";
import { GRID_CONFIG } from "./constants/EditFieldsLayoutConfig";
import { ComboBox } from "@progress/kendo-react-dropdowns";

const getGridConfig = (breakpoint, GRID_CONFIG) => GRID_CONFIG[breakpoint];

const EditFields = props => {
    const { breakpoint } = useBreakpoint(BREAKPOINTS);

    const {
        title,
        inputFieldTitle,
        addFieldTitle,
        removable, 
      } = props;

    const {
        fieldsContainer,
        fieldsItem,
      } = getGridConfig(breakpoint, GRID_CONFIG);

      const [data, setData] = useState(props.data);



    const onAddFieldFilterChange = (event) => {
console.log("filtering");
//        setFilteredFields(filterData(event.filter));
     };

     const handleSelectedFieldToAdd = (event) => {
        if(event && event.target && event.target.value && event.target.value.field){
            let changedField = data.find((item) => item.field === event.target.value.field);
            if(changedField){
                changedField.show = true;

                //Move to the end - more user friendly
                setData([...data.filter(a => a !== changedField), changedField]);
            }
        }
     };


    return <Card>
        <CardTitle>
            {title}:
        </CardTitle>
        <CardBody>
            <FormElement horizontal={true}>
                <GridLayout 
                    gap={{ rows: 0, cols: 20 }}
                    cols={fieldsContainer.cols}
                >
                {Array.from(Array(data.filter(item => item.show && item.editable).length < fieldsItem.divider ? data.filter(item => item.show && item.editable).length : fieldsItem.divider), (e, i) => {
                    return <GridLayoutItem
                    className={i%2 === 0 ? styles.even : styles.odd}
                    key={`gridItem_${i}`}
                    row={1}
                    col={i + 1}
                    >
                        <div style={{display: "flex"}}>
                            <span style={{display:"inline-block", flex: "1 1 auto"}}></span>
                            <span style={{display:"inline-block", width: "70px", textAlign: "center"}}>{inputFieldTitle}</span>
                            {removable && <span style={{display:"inline-block", width: "70px", textAlign: "center"}}>Remove</span>}
                        </div>
                    </GridLayoutItem>
                })}

                {data.filter(item => item.show && item.editable).map((field, idx) => {
                    const row = Math.floor(idx / fieldsItem.divider) + 2;
                    return (
                      <GridLayoutItem
                            className={(idx % fieldsItem.divider)%2 === 0 ? styles.even : styles.odd}
//                            className={styles.fieldsColumn}
                            key={`gridItem_${idx}`}
                            row={row}
                            col={(idx % fieldsItem.divider) + 1}
                        >
                            <ColumnEditFields 
                                key={`editFields_'${idx}'`}
                                column={field}
                                removable={removable}
                            />
                        </GridLayoutItem>
                    );
                })}
                </GridLayout>

                <div style={{marginTop: '40px'}}>
                
                <ComboBox
                        style={{ width: "300px", }}
                        data={data.filter(item => !item.show && item.editable)}
                        textField="title"
                        filterable={true}
                        onFilterChange={onAddFieldFilterChange}
                        dataItemKey="field"
                        defaultValue=""
//                        value={selectedGroup}
                        onChange={handleSelectedFieldToAdd}
                        placeholder={addFieldTitle? addFieldTitle : "Add skill/queue to change..."}
                    />
                </div>
            </FormElement>
        </CardBody>
    </Card>;
};

export default EditFields;
